import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class PasswordErrorStateMatcher implements ErrorStateMatcher {
    public isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
        const pw2IsDirty = form && (<FormGroupDirective>form).form.controls && (<FormGroupDirective>form).form.controls.password2.touched;
        return (invalidParent && pw2IsDirty);
    }
}
